import React, { useState } from 'react';

import { MapContainer, TileLayer, Marker, Popup, ZoomControl } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import bunkerData from '../data/bbr_sikringsrum.json';
import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import L from 'leaflet';

// Import custom marker icons (place these in src/images/)
import sLogo from '../images/sikringsrum.png';
import bLogo from '../images/bunker.png';

// Fix default icon URLs for Leaflet markers
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

// Define custom icons for types S and B
const sIcon = new L.Icon({
  iconUrl: sLogo,
  // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  iconSize: [75, 75],
  iconAnchor: [45, 42],
  popupAnchor: [1, -34],
});
const bIcon = new L.Icon({
  iconUrl: bLogo,
  // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  iconSize: [75, 75],
  iconAnchor: [45, 42],
  popupAnchor: [1, -34],
});

const MapView = () => {
  // Default center on Copenhagen
  const centerPosition = [55.6761, 12.5683];

  const [filterType, setFilterType] = useState('all');

  const filteredData = bunkerData.filter(b => filterType === 'all' || b.Type === filterType);

  return (
    <div style={{ position: 'relative',  }}>
      <div style={{
        position: 'absolute',  zIndex: 1000,
        background: 'rgba(255, 255, 255, 0.9)', padding: '10px 15px', borderRadius: '8px',
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)', fontFamily: 'Arial, sans-serif',
      }}>
        <label htmlFor="typeSelect" style={{ marginRight: '8px', fontWeight: 'bold' }}>Filter</label>
        <label htmlFor="typeSelect">Vis:&nbsp;</label>
        <select id="typeSelect" value={filterType} onChange={e => setFilterType(e.target.value)}>
          <option value="all">Alle</option>
          <option value="Sikringsrum">Sikringsrum</option>
          <option value="Bunker">Bunker</option>
        </select>
      </div>
    <MapContainer 
    center={centerPosition} 
    zoom={13} 
    style={{ height: '100vh', width: '100%' }}
    zoomControl={false}
    >
      <TileLayer
        attribution='&copy; OpenStreetMap contributors, Tiles &copy; JFM'
        url="https://tiles.jfmtech.dk/styles/osm-bright/{z}/{x}/{y}.png"
      />
      <ZoomControl position="bottomright" />
      <MarkerClusterGroup>
        {filteredData.map((bunker, idx) => {
          // Choose icon based on bunker.type ('Sikringsrum' or 'Bunker')          
          const icon = bunker.Type === 'Sikringsrum' ? sIcon : bIcon;
          return (
            <Marker key={idx} position={[bunker.y_lat, bunker.x_long]} icon={icon}>
                 <Popup>
            <div>
              <strong>Adresse:</strong> {bunker.Adgangs_Adresse}<br />
              <strong>Antal pladser:</strong> {bunker.Sikringsrumpladser}<br />
              <strong>Ejerlavsnavn:</strong> {bunker.ejerlavsnavn}<br />
              {/* <strong>Antal ejere:</strong> {bunker.AntalEjere}<br /> */}
              <strong>Ejertype:</strong> {bunker.EjerforholdType}<br />
              {/* {bunker.LinkTilCVR && bunker.LinkTilCVR !== '0' && (
                <div><a href={bunker.LinkTilCVR} target="_blank" rel="noopener noreferrer">Link til CVR</a></div>
              )} */}
            </div>
          </Popup>
            </Marker>
          );
        })}
      </MarkerClusterGroup>
    </MapContainer>
    </div>
  );
};

export default MapView;
